import React, {Component} from 'react';
import { connect } from 'react-redux';
import Note from './Note';

class Notes extends Component {
	constructor(props) {
		super(props);
	}
    render() {
	    let {notes} = this.props;
        return (
            <div className="webnotes_notes-container">
                {
                notes.map(note => (
                	<Note note={note} annotator={this.props.annotator} />
                ))
                }
            </div>
        )
    }
}

const mapStateToProps = state => state;
export default connect(mapStateToProps)(Notes);


// WEBPACK FOOTER //
// ./src/js/components/Notes.js